import luigisboxAnanyticsService, { LuigisboxOrderFinishedProduct } from "../luigisbox/luigisboxAnanyticsService";
import { parseJSONScript } from "../../../js/common/json";
import ajaxClient, { MaxServerError } from "../../../js/common/AjaxClient";
import popupAlertService from "../../../js/common/PopupAlertService";
import elementService from "@/common/ElementService";

export default class OrderFinishedPageService {
    public init(): void {
        const orderTrackingButton = document.querySelector<HTMLButtonElement>(".js-send-order-tracking-url");

        if (orderTrackingButton === null) {
            return;
        }

        this.initOrderTrackingUrls(orderTrackingButton);
        this.sendLuigisboxOrderFinishedEvent();
    }

    private initOrderTrackingUrls(orderTrackingButton: HTMLButtonElement): void {
        orderTrackingButton.addEventListener("click", () => void this.sendOrderTrackingUrl(orderTrackingButton));
    }

    private async sendOrderTrackingUrl(orderTrackingButton: HTMLButtonElement): Promise<void> {
        const orderDetailSent = elementService.querySelector<HTMLSpanElement>(".js-order-detail-sent");

        try {
            await ajaxClient.post(
                "/OrderPayment/jsSendOrderTrackingUrl",
                {
                    orderVarSymbol: elementService.elementData(orderTrackingButton, "orderVarSymbol"),
                },
            );

            orderDetailSent.classList.remove("hidden");
        } catch (error) {
            if (error instanceof MaxServerError) {
                void popupAlertService.showAlert(error.message);
            }

            throw error;
        }
    }

    private sendLuigisboxOrderFinishedEvent(): void {
        luigisboxAnanyticsService.sendOrderFinishedEvent(parseJSONScript<LuigisboxOrderFinishedProduct[]>("#js-luigisbox-transaction"));
    }
}
